import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import User from '../../../../../../../domain/models/user';
import UserProp from '../../../../commonComponents/propTypes/userProp';
import TenantProp, {
  PAYMENT_PROVIDER,
} from '../../../../commonComponents/propTypes/tenantProp';

function OpportunitiesListHeader(props) {
  const { t, loggedUser, tenant } = props;
  const { paymentProviderType } = tenant?.settings || {};
  const { role, type } = loggedUser;

  const isCreateAvailable =
    paymentProviderType !== PAYMENT_PROVIDER.NONE &&
    (role === User.ROLE.ADMIN || type === User.TYPE.COLLABORATOR);

  return (
    <>
      {isCreateAvailable ? (
        <div className="opportunities-headers">
          <a
            href="/shop/opportunities/create"
            className="btn btn-brand btn-md m-btn--pill"
          >
            {t('opportunities.new')}
          </a>
        </div>
      ) : null}
    </>
  );
}

OpportunitiesListHeader.propTypes = {
  t: PropTypes.func.isRequired,
  loggedUser: PropTypes.shape(UserProp.propType).isRequired,
  tenant: PropTypes.shape(TenantProp.propType).isRequired,
};

export default translate(OpportunitiesListHeader);
